/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowEscapeRoomTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowEscapeRoom,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Unlock the Mystery!",
    "Escape the Ordinary!",
    "Adventure Awaits Inside!",
  ],
  title: "Escape Room Adventure",
  description: "Plan a thrilling escape room experience.",
  longDescription:
    "Gather your team for an exciting escape room challenge. Choose a date, select a thrilling theme, and decide on snacks for after the adventure!",
  emoji: "🔐",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Party,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Escape Room Adventure",
          emoji: "🔐",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we escape?",
          emoji: "📅",
          completeAction: {
            question: "Decide on a theme?",
            description: "What theme do you want for the escape room?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What escape room theme should we choose?",
                emoji: "🗝",
                completeAction: {
                  question: "Decide on snacks?",
                  description: "What snacks should we enjoy after our escape?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What snacks should we get?",
                      emoji: "🍪",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Time to Escape!",
    outroDescription:
      "Your escape room adventure is set! Get ready for some thrilling fun!",
  },
};
